import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const responseSchema = z.object({
  current_profile: z.string(),
  seller: z.record(z.string(), z.unknown().array()),
  vendor: z.record(z.string(), z.unknown().array()),
});

export const accountsApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getAccounts",
    method: "get",
    path: "/accounts/",
    parameters: [
      {
        name: "channel",
        type: "Query",
        schema: z.string().optional(),
      },
    ],
    status: 200,
    response: responseSchema,
  }).build(),
);

export type AccountsResponse = z.infer<typeof responseSchema>;
